export const CREATION_POLL_ID = 'app/wizard-export/creation-poll';
